// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3PXld","bigColWidth":"Table_bigColWidth__2olWR","biggerColWidth":"Table_biggerColWidth__SToao","row":"Table_row__1mHgj","col":"Table_col__8LvLT"};